import type { FC } from 'react'
import React from 'react'
import { SortableHandle } from 'react-sortable-hoc'
import { CloseIcon, DragIcon } from '@fourthwall/icons'
import { Icon } from '../../Icon'
import * as S from './SortableListItemToolbar.styled'
import type { SortableListItemToolbarProps } from './types'

const DragHandle = SortableHandle(() => (
  <S.DragHandle title="Drag" data-testid="SortableListItemToolbar.DragHandle">
    <Icon component={DragIcon} height={12} />
  </S.DragHandle>
))

export const SortableListItemToolbar: FC<SortableListItemToolbarProps> = ({ onRemove }) => (
  <S.Container>
    <DragHandle />
    <S.Handle title="Remove" onClick={onRemove} data-testid="SortableListItemToolbar.RemoveHandle">
      <Icon component={CloseIcon} height={12} />
    </S.Handle>
  </S.Container>
)
